


















































import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';
import DatePicker from '@/components/DatePicker.vue';
import dayjs from 'dayjs';
import clone from '@/lib/clone';

@Component({
    components: {DatePicker, Icon}
})
export default class EditRecord extends Vue {
    record?: RecordItem;
    dayjs = dayjs;

    created() {
        this.$store.commit('findRecord', parseInt(this.$route.params.id));
        this.record = clone<RecordItem>(this.$store.state.currentRecord);
        if (!this.record) {
            this.record = {
                id: 0,
                tag: {name: 'food', value: '餐饮'},
                type: '-',
                note: '',
                amount: 0,
                createAt: new Date()
            }; // 消除Vue warn
            this.$router.replace('/error');
        }
    }

    updateYear(year: number) {
        if (this.record) {
            this.record.createAt = dayjs(this.record.createAt).year(year).toDate();
        }
    }

    updateMonth(month: number) {
        if (this.record) {
            this.record.createAt = dayjs(this.record.createAt).month(month - 1).toDate();
        }
    }

    updateDate(date: number) {
        if (this.record) {
            this.record.createAt = dayjs(this.record.createAt).date(date).toDate();
        }
    }

    back() {
        this.$router.replace('/');
    }

    ok() {
        if (this.record) {
            this.record.amount = parseFloat(this.record.amount.toString());
            this.$store.commit('updateRecord', {id: this.record.id, record: this.record});
        }
        this.$router.replace('/');
    }

    remove() {
        if (this.record) {
            this.$store.commit('removeRecord', this.record.id);
            if (this.$store.state.recordListError === 'notfound') {
                window.alert('该记录不存在');
            } else {
                this.$router.replace('/');
            }
        }
    }
}
